import { render, staticRenderFns } from "./repair-detail.vue?vue&type=template&id=6e45d9ec&scoped=true"
import script from "./repair-detail.vue?vue&type=script&lang=js"
export * from "./repair-detail.vue?vue&type=script&lang=js"
import style0 from "./repair-detail.vue?vue&type=style&index=0&id=6e45d9ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e45d9ec",
  null
  
)

export default component.exports